import Vue from 'vue';

export interface NotificationOptions {
  message: string;
  type?: 'is-success' | 'is-info' | 'is-warning' | 'is-danger';
  position?: 'is-top' | 'is-bottom' | 'is-top-right' | 'is-top-left' | 'is-bottom-right' | 'is-bottom-left';
  duration?: number;
}

class NotificationService {
  private static instance: NotificationService;
  private vueInstance: any = null;

  private constructor() {
    // Create a temporary Vue instance to access $buefy
    this.vueInstance = new Vue();
  }

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  public showToast(options: NotificationOptions): void {
    if (this.vueInstance && this.vueInstance.$buefy) {
      this.vueInstance.$buefy.toast.open({
        message: options.message,
        type: options.type || 'is-info',
        position: options.position || 'is-top',
        duration: options.duration || 4000
      });
    } else {
      // Fallback to console if Buefy is not available
      console.warn('Notification:', options.message);
    }
  }

  public showSessionExpiredNotification(): void {
    this.showToast({
      message: 'Your session has expired. You will be redirected.',
      type: 'is-warning',
      position: 'is-top',
      duration: 3000
    });
  }
}

export const notificationService = NotificationService.getInstance(); 